import PCA from 'area-data/pcaa'

let provinceList = []
let cityList = {}
let areaList = {}
Object.keys(PCA['86']).map(i => {
  provinceList.push({
    value: PCA['86'][i],
    id: i,
  })
  cityList[i] = []
  Object.keys(PCA[i]).map(j => {
    cityList[i].push({
      province: PCA['86'][i],
      value: PCA[i][j],
      id: j,
    })
    areaList[j] = []
    Object.keys(PCA[j]).map(q => {
      areaList[j].push({
        city: PCA[i][j],
        value: PCA[j][q],
        id: q,
      })
    })
  })
})

provinceList.forEach(province => {
  province.children = cityList[province.id]
  province.children.forEach(city => {
    city.children = areaList[city.id]
  })
})

export default provinceList
